const MagicUploadIcon = ({ colour = 'white', width = '19', height = '18' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.51331 2.24778C6.51331 5.4332 9.11951 8.0394 12.3043 8.0394C9.11951 8.0394 6.51331 10.6456 6.51331 13.831C6.51331 10.6456 3.90711 8.0394 0.72168 8.0394C3.90651 8.0394 6.51331 5.4332 6.51331 2.24778ZM15.1579 0.976562C15.1579 3.08975 16.8868 4.81855 18.9999 4.81855C16.8868 4.81855 15.1579 6.54736 15.1579 8.66055C15.1579 6.54736 13.4291 4.81855 11.316 4.81855C13.4291 4.81855 15.1579 3.08975 15.1579 0.976562ZM13.5195 10.4685C13.5195 12.2711 14.9944 13.7454 16.7964 13.7454C14.9938 13.7454 13.5195 15.2203 13.5195 17.0224C13.5195 15.2197 12.0446 13.7454 10.2425 13.7454C12.0451 13.7454 13.5195 12.2705 13.5195 10.4685Z"
                fill={colour}
            />
        </svg>
    );
};

export default MagicUploadIcon;
